import leaflet from "leaflet"; 
import { useEffect, useRef, useState } from "react";
import {  useHistory } from "react-router-dom";
import qs from "qs";
import {ErrorGeneral, llamaApiCargaTokenExt} from "../funciones/ClienteAxios";
import axios from 'axios';
import moment from 'moment';
export default function MapaLeaflet({lista, listaPromovid, listCentro, zoom}) {
  const mapRef = useRef()
  //const params = useParams()
  let history = useHistory();
  const source = axios.CancelToken.source();
  const [cargando, setCargando] = useState(true)
  const [centro, setCentro] = useState([-17.3936218,-66.2336069])
  const [listPoligono, setListPoligono] = useState([])
  const hoy=moment(new Date()).format('YYYY-MM-DD')      

  useEffect(()=>{         
    
   // getListPoligono(1, "1", 9, municipioId)
    //getListMarcador(1, "1", 9, municipioId)
    //console.log(lista);
    
   mapRef.current =  leaflet.map('map').setView([19.3805297,-99.1821412], zoom);
    leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(mapRef.current);  

    
    mapRef.current.setView([lista[0].coordenada[0].lat, lista[0].coordenada[0].lng]);
    let arrPoligono=[],arrColor=[]
    lista.forEach((poligono)=>{
      let arrPath=[]
      if (poligono.coordenada) {
        poligono.coordenada.forEach((paths)=>{
          arrPath.push([paths.lat,paths.lng])
          
        })
      }
      arrColor.push(poligono.color )
      arrPoligono.push(arrPath)
     
    })   
    const options ={ fillOpacity: 0.5, fillColor: "#c21214" }
    //console.log(options);
    
    const polygon = leaflet.polygon(arrPoligono, { fillOpacity: 0.5, fillColor: "#c21214" } );
    polygon.addTo(mapRef.current); 

    return () => {
      mapRef.current = null
      source.cancel();
    }

  },[]) 

  useEffect(()=>{         
    //console.log(listCentro);
    
    if (listCentro && listCentro.lenght!== 0 ) {
      listCentro.forEach((poligono)=>{
        if (poligono.Id!== -1 && poligono.Id!== "-1" ) 
        { let arrPath=[]
          if (poligono.coordenada) {
            
            //arrPath.push([poligono.coordenada.lat, poligono.coordenada.lng])
            
          }      
          const promoIcon = nvoIconLeaflet('/marker-icon-2x-green.png')

          let marker = leaflet.marker([poligono.coordenada.lat, poligono.coordenada.lng],{icon:promoIcon});    
          const cadena=`${poligono.nombre}`          
          marker.bindPopup(cadena).openPopup();
          marker.addTo(mapRef.current).on('click', mostrar);  
        }
        
      })         
    }                  
    
 
  },[listCentro, ])  

  const nvoIconLeaflet=(iconUrl, iconAncho)=>{
    const nvo=new leaflet.Icon({
      iconUrl: iconUrl,
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [iconAncho??25, 41],
      iconAnchor: [iconAncho??12, 41],
      popupAnchor: [1, -34],
      shadowSize: [iconAncho??41, 41]
    });
    return nvo
  }
  

  const mostrar=(e)=>{
    //console.log(e);    
  }
 
  return (  
    <div id="map" ref={mapRef} style={{height:"100%" }}/>  
  );
}